export default __webpack_public_path__ + "static/pro@992_2x-3ee33c105db4807c84e13a7b75f14862.webp";